import request from '../../shared/request'

export function getAllTasks() {
  return request('/tasks')
}

export function createTask(payload) {
  return request(`/tasks`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function editTask(payload) {
  return request(`/tasks/${payload.taskId}`, {
    method: 'PUT',
    body: payload.content,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function deleteTask(payload) {
  return request(`/tasks/${payload.taskId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}

export function mainQuickAddTask(payload) {
  return request(`/tasks/`, {
    method: 'POST',
    body: payload,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    }
  })
}



// WEBPACK FOOTER //
// ./src/redux/api/task.js